import React from "react";
import { Circle as KonvaCircle } from "react-konva";

const Circle = ({ shape, shapeProps }) => {
	return (
		<KonvaCircle
			{...shapeProps}
			key={shape.id}
			x={shape.x}
			y={shape.y}
			radius={shape.radius}
			fill="rgba(100, 100, 100, 0.89)"
			stroke="rgba(100, 100, 100, 1)"
			strokeWidth={1}
		/>
	);
};

export default Circle;
